export function normalizePhoneToE164(
  input: string | undefined | null,
): string | null {
  if (!input) return null;

  const trimmed = input.trim();
  if (!trimmed || !/^[+\d\s().\/-]+$/.test(trimmed)) return null;

  let cleaned = trimmed.replace(/[\s().\/-]/g, "");
  if (!cleaned) return null;

  if (cleaned.startsWith("00")) {
    cleaned = "+" + cleaned.slice(2);
  }

  if (cleaned.startsWith("+")) {
    const digits = cleaned.slice(1);
    if (/^\d{8,15}$/.test(digits)) return cleaned;
    return null;
  }

  const digits = cleaned;
  if (digits.length === 9) {
    return `+420${digits}`;
  }
  if (digits.length >= 11 && digits.length <= 15) {
    return `+${digits}`;
  }

  return null;
}
